import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

const Root = styled.div`
  width: 100%;
`;

const TitleSlot = styled.div`
  margin-left: 32px;
  margin-bottom: 0;
`;

const SectionBox = styled.div`
  margin-bottom: 26px;
  position: relative;
  padding: 20px 11px;
  border: 1px solid #727272;
  border-radius: 8px;
  filter: drop-shadow(0px 0px 2.5px rgba(0, 0, 0, 0.26));
`;

const HideSlot = styled.div`
  position: absolute;
  top: -19px;
  right: 8px;
  z-index: 1;
`;

const BookList = styled.ul`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;
  @media (min-width: 1200px) {
    flex-wrap: nowrap;
  }
  @media (max-width: 992px) {
    margin-left: 0;
  }
`;

const BookCell = styled.li`
  margin: 11px;
  box-sizing: border-box;
  flex: 1 1 110px;
  max-width: 150px;
  min-width: 100px;
  @media only screen and (min-width: 600px) and (max-width: 800px) {
    flex: 0 0 calc(50% - 32px);
    max-width: none;
  }
  @media (min-width: 768px) and (max-width: 1200px) {
    margin: 8px 8px 6px;
    flex: 1 1 120px;
  }
  @media only screen and (max-width: 600px) {
    flex: 0 0 calc(50% - 32px);
    max-width: none;
  }
`;

const CardColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CoverFrame = styled.div`
  width: 100%;
  border-radius: 3px 3px 0 0;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  position: relative;
`;

const CoverOverlay = styled.div`
  position: absolute;
  bottom: 8px;
  left: 8px;
  right: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  pointer-events: none;
`;

const BookFooter = styled.div`
  width: 100%;
  min-height: 48px;
  background: #1b2d4f;
  border-radius: 0 0 3px 3px;
  padding: 10px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;

const FooterLineSkeleton = styled(Skeleton)`
  width: 100%;
  margin: 0 !important;
  .ant-skeleton-paragraph {
    margin-top: 0 !important;
  }
  .ant-skeleton-paragraph > li {
    background: rgba(255, 255, 255, 0.22) !important;
  }
`;

const TitleBarSkeleton = styled(Skeleton.Input)`
  &.ant-skeleton-element .ant-skeleton-input {
    min-width: 224px;
    height: 38px;
    border-radius: 15px 15px 0 0;
  }
`;

const BOOK_COUNT = 8;

const StudentDashboardHomeSkeletonPage: React.FC = () => (
  <Root>
    <TitleSlot>
      <TitleBarSkeleton active size="default" style={{ width: 300 }} />
    </TitleSlot>
    <SectionBox>
      <HideSlot>
        <Skeleton.Button active size="small" style={{ width: 72, height: 32, borderRadius: 4 }} />
      </HideSlot>
      <BookList>
        {Array.from({ length: BOOK_COUNT }).map((_, bookIndex) => (
          <BookCell key={bookIndex}>
            <CardColumn>
              <CoverFrame>
                <Skeleton.Node active style={{ width: '100%', height: 200, display: 'block' }} />
                <CoverOverlay>
                  <Skeleton.Avatar active size={22} shape="square" style={{ borderRadius: 4 }} />
                  <Skeleton.Avatar active size={22} shape="circle" />
                </CoverOverlay>
              </CoverFrame>
              <BookFooter>
                <FooterLineSkeleton active title={false} paragraph={{ rows: 1, width: ['88%'] }} />
              </BookFooter>
            </CardColumn>
          </BookCell>
        ))}
      </BookList>
    </SectionBox>
  </Root>
);

export default StudentDashboardHomeSkeletonPage;
